import { z } from 'zod';
import { zStringRequired } from '../../z';
import { registry } from '../registry';
const yesNoOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
];
export const baseLVNSupervisory = z.object({
    arrivesAsScheduled: zStringRequired().register(registry, {
        label: 'Arrives for assigned visits as scheduled',
        options: yesNoOptions,
    }),
    followsPOC: zStringRequired().register(registry, { label: "Follows client's plan of care", options: yesNoOptions }),
    positiveAttitude: zStringRequired().register(registry, {
        label: 'Demonstrates positive and helpful attitude towards the client and others',
        options: yesNoOptions,
    }),
    reportsChanges: zStringRequired().register(registry, {
        label: 'Informs Nurse Supervisor/Case Manager of client needs and changes in condition',
        options: yesNoOptions,
    }),
    useUniversalPrecautions: zStringRequired().register(registry, {
        label: 'Implements Universal Precautions per agency policy',
        options: yesNoOptions,
    }),
    ptConditionChanges: zStringRequired().register(registry, {
        label: 'Any changes made to client plan of care at this time',
        options: yesNoOptions,
    }),
    ptSatified: zStringRequired().register(registry, {
        label: 'Patient/CG satisfied with care and services provided by LVN/LPN',
        options: yesNoOptions,
    }),
    comments: z.string().optional().register(registry, { label: 'Comments' }),
});
export const lvnSupervisoryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        evaluation: baseLVNSupervisory,
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
